import {
    Button,
    Text,
    VStack,
    Link,
    Box,
} from '@chakra-ui/react';
import {
    faCheckCircle,
} from '@fortawesome/pro-light-svg-icons';
import { FaIcon } from '@acp/core-ui';
import { ReportedFindingsMachineContext } from '../machine/context';

function QuoteRequestComplete() {
    const machine = ReportedFindingsMachineContext.useActorRef();

    return (
        <VStack align="left" w="100%" spacing={4} mt={4}>
            <VStack w="100%" alignItems="center" gap={4} pb={10}>
                <FaIcon w={12} h={12} icon={faCheckCircle} color="success.500" />
                <Text fontSize="xl" fontWeight="medium">
                    Thanks for your request
                </Text>
                <Box textAlign="center">
                    <Text fontSize="md" color="muted.700">
                        Your quote will be prepared by our team and sent
                    </Text>
                    <Text fontSize="md" color="muted.700">
                        to you when it&apos;s ready.
                    </Text>
                </Box>
                <Box textAlign="center" mb={4} mt={2}>
                    <Text fontSize="md" color="muted.700">
                        Great work! You&apos;re on a roll.
                    </Text>
                    <Text fontSize="md" color="muted.700">
                        Want to resolve some more?
                    </Text>
                </Box>
                <Button
                    colorScheme="black"
                    size="md"
                    variant="solid"
                    onClick={() => machine.send({ type: 'RESOLVE_MORE' })}
                >
                    <Text>Continue</Text>
                </Button>

                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                <Link
                    _hover={{ textDecoration: 'underline' }}
                    fontWeight="normal"
                    fontSize="md"
                    color="muted.500"
                    mt={4}
                    onClick={() => machine.send({ type: 'FORCE_CLOSE_MODAL' })}
                >
                    <Text color="muted.700">
                        No thanks, I&apos;m finished
                    </Text>
                </Link>
            </VStack>
        </VStack>
    );
}

export { QuoteRequestComplete };
